"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _upperFirst2 = _interopRequireDefault(require("lodash/upperFirst"));
var _transform2 = _interopRequireDefault(require("lodash/transform"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _componentTheme = require("@clds/component-theme");
var _componentEnhancer = require("@clds/component-enhancer");
var _iconMixin = _interopRequireDefault(require("./iconMixin"));
var icons = _interopRequireWildcard(require("./icons"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StyledIcon = _styledComponents.default.svg.withConfig({
  displayName: "Icon__StyledIcon"
})(["display:inline-block;vertical-align:top;", ";"], _iconMixin.default);
const StyledPath = _styledComponents.default.path.withConfig({
  displayName: "Icon__StyledPath"
})(["fill:", ";"], props => props.variant ? _componentTheme.globalTheme.palette[props.variant] : props.color ? props.color : 'currentColor');
const Icon = (0, _componentEnhancer.asStyledComponent)( /*#__PURE__*/_react.default.forwardRef(({
  name,
  variant,
  color,
  ...props
}, ref) => /*#__PURE__*/_react.default.createElement(StyledIcon, _extends({
  "data-test": "icon"
}, props, {
  viewBox: "0 0 24 24",
  preserveAspectRatio: "xMidYMid",
  ref: ref
}), [].concat(icons[name]).map((path, idx) => /*#__PURE__*/_react.default.createElement(StyledPath, {
  variant: variant,
  color: color,
  d: path,
  key: `${name}-${idx}`
})))));
exports.Icon = Icon;
Icon.displayName = 'Icon';
const Icons = (0, _transform2.default)(icons, (res, _, name) => {
  // Todo this is temporary. This whole section will be removed in PR 1480
  //istanbul ignore next
  const wrappedIcon = props => /*#__PURE__*/_react.default.createElement(Icon, _extends({
    name: name
  }, props));
  const iconName = (0, _upperFirst2.default)(name);
  wrappedIcon.displayName = `Icon.${iconName}`;
  return res[iconName] = wrappedIcon;
});
Object.assign(Icon, Icons);
Icon.propTypes = {
  color: _propTypes.default.string,
  variant: _propTypes.default.string,
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  name: _propTypes.default.string
};
//# sourceMappingURL=Icon.js.map